import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const SkillBar = ({ name, percentage, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (isInView && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [isInView, hasAnimated]);

  return (
    <div ref={ref} className="mb-4 sm:mb-6" data-testid={`skill-${name.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex justify-between items-center mb-1.5 sm:mb-2">
        <span className="text-xs sm:text-sm font-medium text-foreground">{name}</span>
        <span className="text-xs sm:text-sm font-medium text-primary">{percentage}%</span>
      </div>
      <div className="h-1.5 sm:h-2 w-full bg-secondary rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: hasAnimated ? `${percentage}%` : 0 }}
          transition={{
            duration: 1,
            delay: delay,
            ease: "easeOut",
          }}
          className="h-full skill-bar-gradient rounded-full"
        />
      </div>
    </div>
  );
};

export default SkillBar;
